import { c } from '../../../utils/tailwind-merge';
import { Chip } from '../../atoms/Chip/Chip';
import { ChipListProps } from './ChipList.types';

export const ChipList = ({
  items,
  link,
  className = '',
  onClickChipList,
}: ChipListProps) => {
  const chipList = (
    <>
      {items.map((item) => (
        <Chip
          key={item}
          label={item}
          link={link}
          className={className}
          onClick={onClickChipList ? () => onClickChipList(item) : undefined}
        />
      ))}
    </>
  );

  return (
    <div
      className={c('flex flex-wrap items-start gap-3 text-grey-900', className)}
    >
      {chipList}
    </div>
  );
};
